__turbopack_context__.v({
  "container": "GallerySection-module-scss-module__yLyxJa__container",
  "fullWidthImage": "GallerySection-module-scss-module__yLyxJa__fullWidthImage",
  "grid": "GallerySection-module-scss-module__yLyxJa__grid",
  "halfWidthImage": "GallerySection-module-scss-module__yLyxJa__halfWidthImage",
  "image": "GallerySection-module-scss-module__yLyxJa__image",
  "lastImage": "GallerySection-module-scss-module__yLyxJa__lastImage",
  "video": "GallerySection-module-scss-module__yLyxJa__video",
});
